import { Modal } from 'antd';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/TimeKeeperSystemType/TimeKeeperSystemTypeModel';
import { RootState } from '../../../store';
import TimeKeeperSystemTypeForm from '../TimeKeeperSystemTypeForm/TimeKeeperSystemTypeForm';

const TimeKeeperSystemTypeModal: FC<any> = () => {
  const dispatch = useDispatch();
  const reduxTimeKeeperSystemType = useSelector((state: RootState) => state.models.timeKeeperSystem);

  return (
    <Modal
      title={!!reduxTimeKeeperSystemType.id ? 'Modifica' : 'Adauga'}
      open={reduxTimeKeeperSystemType.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <TimeKeeperSystemTypeForm />
    </Modal>
  );
};

export default TimeKeeperSystemTypeModal;
